<template>
  <div
      class="tab-pane fade"
      :class="{ 'show active': isActive }"
      id="nav-home"
      role="tabpanel"
      aria-labelledby="nav-home-tab"
      tabindex="0"
  >
    <h1>Progress:</h1>
    <div class="tbl-wrpr-overAll table-responsive">
      <table>
        <tbody>
        <tr>
          <th></th>
          <th>Overall</th>
          <th>Yearly ({{ currentYear }})</th>
          <th>Monthly <span style="text-transform: capitalize;">({{ currentMonth.format("MMM") }})</span></th>
          <th>Weekly ({{currentWeek}})</th>

        </tr>

        <!-- loop tableData   -->
        <tr v-for="(data, key) in tableData" :key="key" >
          <td>{{ camelCaseToWords(key) }}</td>
          <td v-if="key === 'distance'" >{{ userData?.data?.PlayerData?.PlayerPersonalStruct?.TotalKilometers?.toFixed(2) }}KM</td>
          <td v-else-if="key === 'timeSpend'">{{ (userData?.data?.PlayerData?.PlayerPersonalStruct?.TotalRideTime / 3600 ).toFixed(2)  }} h</td>
          <td v-else-if="key === 'elevation'" >{{ userData?.data?.PlayerData.PlayerPersonalStruct?.TotalElevation.toFixed(2) }}M</td>
          <td v-else-if="key === 'races'" >{{ totalEvents }}</td>
          <td v-else >{{ data.overall }}</td>
          <td>{{ data.year  }}</td>
          <td>{{ data.month }}</td>
          <td>{{ data.week }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <section>
      <div class="searchMainWrpr-dayWeek my-3">
        <div class="row justify-content-between">
          <div class="col-sm-12 col-md-12 col-lg-8 col-xl-7 col-xxl-7">
            <div class="select my-1">
              <select v-model="durationType" class="form-select duration-type" aria-label="Default select example" name="duration-type" id="duration-type">
                <option value="week">THIS WEEK</option>
                <option value="month">THIS MONTH</option>
                <option value="year" selected>THIS YEAR</option>
              </select>
            </div>
            <div class="select my-1 float-end">
              <select v-model="dataType" name="data-type" id="data-type" class="data-type">
                <option value="distance" selected>DISTANCE</option>
                <option value="elevation">ELEVATION</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-5 col-xxl-5">
          </div>

        </div>
      </div>
    </section>

    <section class="chart-div">
      <div class="container">
        <BarChartGenerator
            :chart-data="getChartData"
            :chart-options="getChartOption"

        />
      </div>
    </section>
  </div>
</template>
<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import {Bar as BarChartGenerator} from 'vue-chartjs/legacy'
import {overviewMixin} from "@/mixins/overviewMixin";
import moment from "moment";



ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
export default {
  name: 'OverView',
  components: {
    BarChartGenerator
  },
  props: ['isActive','userData','totalEvents'],
  mixins: [
    overviewMixin
  ],
  data() {
    return {

      currentYear: new Date().getFullYear(),
      currentMonth:  moment(new Date()), // Months are zero-based, so add 1
      // currentWeek: this.getWeekNumber(),
     // currentWeek: moment(new Date()).week() - moment(new Date()).startOf('month').week() + 1,
      currentWeek: moment().startOf('week').diff(moment().startOf('month').startOf('week'), 'weeks') + 1,
      durationType: 'year', // Default duration type
      dataType: 'distance', // Default data type
      barChartOptions: {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            intersect: false
          },
          crosshair: false,
        },
        elements: {
          point: {
            radius: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {

          x: {
            beginAtZero: true,
            // grid: {
            //   display: false,
            //   drawBorder: false
            // },
            // ticks: {
            //   display: false
            // }
          },
          y: {
            beginAtZero: true,
            min: 0
            // grid: {
            //   display: false,
            //   drawBorder: false
            // },
            // ticks: {
            //   display: false
            // }
          }
        },
      },
      tableData: {},
      barChartDataSet: {
        labels: [],
        datasets: [{
          label: 'Elevation',
          backgroundColor:  '#357fdd',
          data: [],
          borderColor: '#ffffff',
          borderWidth: 2,
          barThickness: 30,
          maxBarThickness: 50,
        }]
      },
    }
  },
  async mounted() {

    await this.fetchData();
    await this.handleDataChange();


  },
  computed:{
    getChartData(){
      return this.barChartDataSet
    },
    getChartOption(){
      return this.barChartOptions
    }

  },
  watch: {
    durationType: 'handleDataChange',
    dataType: 'handleDataChange',
  },
  methods: {

    camelCaseToWords(s) {

      const rowName = {'timeSpend' : 'Time spent','allRides':'All rides','distance':'Distance',
        'elevation':'Elevation ','longestRide':'Longest ride'
        ,'races':'Race'};

      return rowName[s]
    },
    async fetchData() {
      try {
        const response = await this.$store.dispatch('ride/over_grid_data', this.getDurationCollection());

        if(!response.success) {
          return;
        }

        const getData = response.data;
        const formatValue = (value, unit) => `${parseFloat(value).toFixed(2)} ${unit}`;
        const unitMap = {
          distance: 'KM',
          timeSpend: 'h',
          elevation: 'M',
          longestRide: 'KM',
        };
        const sortedData = {
          distance: {},
          timeSpend: {},
          elevation: {},
          longestRide: {},
          races: {},
          allRides: {},
        };

        Object.keys(getData).forEach((key) => {
          const data = getData[key];

          Object.keys(data).forEach((dataKey) => {

            if (dataKey === 'name') return;

            if (unitMap[dataKey]) {
              data[dataKey] = formatValue(data[dataKey].toFixed(2), unitMap[dataKey]);
            }
            if(dataKey == 'timeSpend'){
              sortedData[dataKey][key] = (parseFloat(data[dataKey]) / 60).toFixed(2) + " h";
            }else{
              sortedData[dataKey][key] = data[dataKey];
            }


          });
        });

        this.tableData = sortedData;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    async handleDataChange() {
      this.barChartDataSet = await this.fetchBarChartData(this.durationType, this.dataType);
    },
  },
}
</script>
<style>
#nav-home > div > table > tbody > tr:nth-child(5),#nav-home > div > table > tbody > tr:nth-child(7){
  display: none;
}

</style>
